import type { HTMLAttributes, ReactNode } from "react";
import { type SwipeEventData, useSwipeable } from "react-swipeable";
import { useSwipeableEnabled } from "../../hooks/useSwipeableEnabled";

const isTextSelected = (): boolean => {
	const selection = window.getSelection();
	return selection !== null && selection.toString().length > 0;
};

interface SwipeableProps
	extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
	children: ReactNode;
	onSwipedLeft?: (e: SwipeEventData) => void;
	onSwipedRight?: (e: SwipeEventData) => void;
	onSwipedUp?: (e: SwipeEventData) => void;
	onSwipedDown?: (e: SwipeEventData) => void;
	onSwiping?: (e: SwipeEventData) => void;
	onSwiped?: (e: SwipeEventData) => void;
	delta?: number;
}

const Swipeable = ({
	children,
	onSwipedLeft,
	onSwipedRight,
	onSwipedUp,
	onSwipedDown,
	onSwiping,
	onSwiped,
	delta = 100,
	...props
}: SwipeableProps) => {
	const { isSwipeableOn } = useSwipeableEnabled();
	const handlers = useSwipeable({
		onSwiping: (e) => {
			if (isSwipeableOn && !isTextSelected() && onSwiping) {
				onSwiping(e);
			}
		},
		onSwiped: (e) => {
			if (onSwiped) onSwiped(e);
		},
		onSwipedLeft: (e) => {
			if (isSwipeableOn && !isTextSelected() && onSwipedLeft) {
				onSwipedLeft(e);
			}
		},
		onSwipedRight: (e) => {
			if (isSwipeableOn && !isTextSelected() && onSwipedRight) {
				onSwipedRight(e);
			}
		},
		onSwipedUp: (e) => {
			if (isSwipeableOn && !isTextSelected() && onSwipedUp) {
				onSwipedUp(e);
			}
		},
		onSwipedDown: (e) => {
			if (isSwipeableOn && !isTextSelected() && onSwipedDown) {
				onSwipedDown(e);
			}
		},
		delta,
		preventDefaultTouchmoveEvent: true,
	});
	return (
		<div {...handlers} {...props}>
			{children}
		</div>
	);
};

export { Swipeable };
